import React from 'react'
import { Form } from 'semantic-ui-react'
import { TooltipLabel } from 'components/TooltipLabel'
import { CrownBadge } from 'components/ProFeatureLabel'

/**
 *
 * @param {object} props
 * @param {string=} props.surveyDomain
 * @param {boolean} props.enableCustomizeBranding
 */
export default function CustomSurveyURLSection({
  surveyDomain: surveyDomainLink,
  enableCustomizeBranding,
}) {
  const surveyDomain = surveyDomainLink
    ? surveyDomainLink.replace(/https:\/\/|http:\/\//gi, '')
    : 'survey.simplesat.io'

  return (
    <Form.Field>
      <TooltipLabel
        label="Web survey display URL"
        descriptionTitle={<span>Host mapping {!enableCustomizeBranding && <CrownBadge />}</span>}
        descriptionContent={
          <React.Fragment>
            <p>Host mapping is used to map one of your own domain names to a Simplesat survey.</p>
            <p>For example, survey.mycompany.com instead of survey.simplesat.io.</p>
          </React.Fragment>
        }
        learnMoreLink="https://help.simplesat.io/en/articles/5051375-survey-branding-design#web-survey-display-url"
        showGotoBillingPage={!enableCustomizeBranding}
      />
      <div className="ui labeled input">
        <div className="ui label label">https://</div>
        <input type="text" placeholder={surveyDomain} disabled readOnly />
      </div>
    </Form.Field>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/BrandSettings/CustomSurveyURLSection.js